//=============================================================================
// Contents   : HRDB
//              転出日一覧
//              GetMoveOutList
// Author     : RV小寺
// LastUpdate : 2023/3/24
// Since      : 2022/12/12
//=============================================================================

/* ======================================================================================================================================================= */  
/* ==================================================================== Start Of Program ================================================================= */  
/* ======================================================================================================================================================= */ 


/* ======================================================================== */  
/* ============================ import ==================================== */  
/* ======================================================================== */  

/* ====== React ====== */
import React from "react";

/* ====== CSS ====== */

/* ====== Image ====== */

/* ====== Component Js/Jsx ====== */

/* ====== Style ====== */
import { GetListTemp } from "01Pages/Template/GetListTemp";
import { CFDateFormatEdit } from "03CommonApiParts/CommonFunction";
/* ======================================================================== */  
/* ============================ Styles ==================================== */  
/* ======================================================================== */  

/* ======================================================================== */  
/* ================== global variables/functions ========================== */  
/* ======================================================================== */  

/* ======================================================================== */  
/* ================================ dummy ================================= */  
/* ======================================================================== */  



/* ======================================================================== */  
/* ============================ Main ====================================== */  
/* ======================================================================== */  

/* ========= 転出日一覧 ========= */
export const GetMoveOutList = () => {

    /* ---------------------------------------------------- */
    /* ------------------ Instance ------------------------ */
    /* ---------------------------------------------------- */

    /* ----------------------------------------------------- */
    /* ----------------- reack-hook-form ------------------- */
    /* ----------------------------------------------------- */

    /* ====== useWatchを定義 ====== */ 

    /* ---------------------------------------------------- */
    /* ------------------ variables ----------------------- */
    /* ---------------------------------------------------- */

    /* ====== sessionStorageからの情報を定義 ====== */ 

    /* ====== localStorageからの情報を定義 ====== */ 

    /* ====== storageから取得した情報をJavaScriptオブジェクトに変換 ====== */ 




    /* ---------------------------------------------------- */
    /* ---------------------- state ----------------------- */
    /* ---------------------------------------------------- */

    
    /* ---------------------------------------------------- */
    /* ---------------------- function -------------------- */
    /* ---------------------------------------------------- */
    
    /* ---------------------------------------------------- */
    /* ----------------------- data ----------------------- */
    /* ---------------------------------------------------- */
    /* ====== 取得API項目の設定 ====== */
	const getConfig = {
        key:[
            {name:'moveOutDateFrom' ,   base64:false},
            {name:'moveOutDateTo' ,     base64:false}
        ],
        payload:[
            {name:'moveOutDate',          base64:false},
            {name:'lastToWorkDate',       base64:false},
            {name:'empNmb',               base64:false},
            {name:'empFullName',          base64:true},
            {name:'empiSttsName',         base64:true},
            {name:'dptCd',                base64:false},
            {name:'dptHqName',            base64:true},
            {name:'dptPartName',          base64:true},
            {name:'dptRomName',           base64:true},
            {name:'dptGpName',            base64:true},
            {name:'dptOrd',               base64:false},
            {name:'tmpAgnSecFrmCmpName',  base64:true},
            {name:'moveOutRemaField',     base64:true},
            {name:'lastUdr',              base64:true},
            {name:'lastUpDate',           base64:false},
        ]              
    };
    /* ======== テーブルの設定 ======== */
    /*------ ヘッダの設定 ------*/
    // id       : 項目名
    // id2       : 項目名2
    // rowSpan  : 2~ (縦に結合)
    // colSpan	: 2~ (横に結合)
    // align	: 整列(横方向) Center/inherit/justify/left/right
    // sortTable: true(ソート)
    // fixed	: 位置固定 true
    // left		: 左からの位置	0~
    // right	: 右からの位置 0~
    // width    : セルの幅
    // label1	: 表示名(1段目)
    // label2	: 表示名(2段目)
    // mark     : 入力必須を表す*を表示　true

    /* ====== テーブルヘッダーを定義 ====== */
    const headData = [
    	{ id: 'moveOutDate', align: 'left', width: '100px', sortTable:true, label1: '転出日' ,fixed:true,left:'0px' },
    	{ id: 'lastToWorkDate', align: 'left', width: '115px', sortTable:true,fixed:true,left:'105px', label1:'最終出社日'},
        { id: 'empNmb', align: 'left', width: '115px', sortTable:true, label1: '従業員番号',fixed:true,left:'224px'},
        { id: 'empFullName', align: 'left', width: '120px', sortTable:true, label1: '氏名',fixed:true,left:'344px',borderRight:'1px solid #c0c0c0' },
    	{ id: 'empiSttsName', align: 'left', width: '100px', sortTable:true, label1: '雇用形態' },
        { id: 'dptCd', align: 'left', width: '115px', sortTable:true, label1: '部署コード' },
        { id: 'dptHqName', align: 'left', width: '260px', sortTable:true, label1: '部署' },
        { id: 'dptOrd', align: 'left', width: '100px', sortTable:true, label1: '部署順' },
        { id: 'tmpAgnSecFrmCmpName', align: 'left', width: '200px', sortTable:true, label1: '派遣元・出向会社' },
        { id: 'moveOutRemaField', align: 'left', width: '250px', sortTable:true, label1: '備考' },
        { id: 'lastUdr', align: 'left', width: '120px', sortTable:true, label1: '最終更新者' },
        { id: 'lastUpDate', align: 'left', width: '120px', sortTable:true, label1: '最終更新日' },
    ];
    
    
        /*====== BodyCellの設定 ======*/
    // name		    : 項目名
    // name2		: 項目名2 値を２つ受け取りたい場合
    // type         : cellの種類　button/checkBox/lable/numLable/labelRaito/labelMonth
    // align	    : 整列(横方向) Center/inherit/justify/left/right *全て（ただしinputの場合はinputの中の文字の位置を指定）
    // width        : selectの幅調整用
    // color        : 文字の色
    // backgroundColor: 背景の色
    // checkBox     : チェックボックスの名前  *input,checkBox
    // fontSize	    : 文字の大きさ デフォルトは12px *label,labelNum
    // color	    : フォントカラーまたはアイコンカラー(アイコンの場合はred/green/grayが選択可能) *label,labelNum,iconButton
    // func         : 処理 *button,iconButton,select
    // value		: btnFuncで受け取りたい値 *button,iconButton

    /* ====== テーブルデータを定義 ====== */
    const bodyData = [
        { name: 'moveOutDate', type: 'dateLabel',  align: 'left' ,fixed:true,left:'0px'},
        { name: 'lastToWorkDate', type: 'dateLabel',  align: 'left',fixed:true,left:'105px'},
        { name: 'empNmb', type: 'label',  align: 'left',fixed:true,left:'224px'},
        { name: 'empFullName', type: 'label',  align: 'left',fixed:true,left:'344px',borderRight:'1px solid #c0c0c0'},
        { name: 'empiSttsName', type: 'label',  align: 'left'},
        { name: 'dptCd', type: 'label',  align: 'left'},
        { name: 'dptHqName', name2:'dptPartName', name3:'dptRomName', name4:'dptGpName', type: 'label',  align: 'left'},
        { name: 'dptOrd', type: 'label',  align: 'left'},
        { name: 'tmpAgnSecFrmCmpName', type: 'label',  align: 'left'},
        { name: 'moveOutRemaField', type: 'label',  align: 'left'},
        { name: 'lastUdr', type: 'label',  align: 'left'},
        { name: 'lastUpDate', type: 'timeLabel',  align: 'left'},
    ];

    /* ======== エクセルの設定 ======== */
    const excelConfig = [
        { id:'moveOutDate', name:'転出日', type:'date'},
        { id:'lastToWorkDate', name:'最終出社日', type:'date'},
        { id:'empNmb', name:'従業員番号', type:'normal'},
        { id:'empFullName', name:'氏名', type:'normal'},
        { id:'empiSttsName', name:'雇用形態', type:'normal'},
        { id:'dptCd', name:'部署コード', type:'normal'},
        { id:'dptHqName', name:'本部', type:'normal'},
		{ id:'dptPartName', name:'部', type:'normal'},
		{ id:'dptRomName', name:'室', type:'normal'},
		{ id:'dptGpName', name:'G', type:'normal'},
        { id:'dptOrd', name:'部署順', type:'normal'},
        { id:'tmpAgnSecFrmCmpName', name:'派遣元・出向会社', type:'normal'},
        { id:'moveOutRemaField', name:'備考', type:'normal'},
        { id:'lastUdr', name:'最終更新者', type:'normal'},
        { id:'lastUpDate', name:'最終更新日', type:'time'}
    ]

    /* ======== ページヘッダーの設定 ======== */
    /*------ ページヘッダーの設定 ------*/
    // id         : 項目名
    // name       : 項目名
    // type       : 種類 input/select/checked/searchButton/clearButton
    // range      : selectbox中身
    // type       : 種類 input/select/checked/searchButton/clearButton
    // width      : 幅幅調整用
    // maxLength  : 最大桁数を定義
    // minLength  : 最小桁数を定義
    // placeholder: Input内のテキスト
    // required   : 必須定義
    // disabled   : 操作不可
    // func       : 処理 *button,iconButton,select
    // checked    :defoltCheckを定義

    /* ====== 検索初期値を定義 ====== */
    // 日付の初期値作成
    const today = new Date()
    const formatedToday = CFDateFormatEdit(today)
    const defaultSearch = {
        moveOutDateFrom:formatedToday,
        moveOutDateTo:formatedToday
    } 
    /* ====== 検索欄(左)を定義 ====== */
    const searchContentsLeft = [
        {id:'moveOutDateFrom',name:'転出日from',type:'date',endDate:'moveOutDateTo'},
        {id:'symbol',name:'～',type:'label'},
        {id:'moveOutDateTo',name:'転出日to',type:'date',startDate:'moveOutDateFrom'},
        {id:'search',type:'searchButton'},
        {id:'clear',type:'clearButton'},
    ];
    
    /* ====== 検索欄(右)を定義 ====== */
    const searchContentsRight = [
    {id:'excel',type:'excelButton', excelTitle:'転出日一覧', excelConfig:excelConfig},  
 ];



    /* ---------------------------------------------------- */
    /* ----------------------- jsx ------------------------ */
    /* ---------------------------------------------------- */

    

    /* ---------------------------------------------------- */
    /* -------------------- Start Render ------------------ */
    /* ---------------------------------------------------- */

    return(
        <>
			<GetListTemp
				listType='list'//一覧タイプ(list:編集なし/listEditable:編集可/listOrderBy:表示順更新)
                initialSearch={true}//初期検索有無
                searchCount={true}//検索件数表示
				pageTitle='転出日一覧'//画面タイトル
                searchContentsLeft={searchContentsLeft}//検索欄左設定
				searchContentsRight={searchContentsRight}//検索欄右設定
				apiPath='/employee/getlistmoveout'//一覧取得のApiPath
                defaultSearch={defaultSearch}
				getConfig={getConfig}//テーブル取得設定
				headData={headData}//テーブルヘッダ設定
				bodyData={bodyData}//テーブルボディ設定
			/>
        </>
    );
};

/* ======================================================================================================================================================= */  
/* ==================================================================== End Of Program =================================================================== */  
/* ======================================================================================================================================================= */ 